// Tailwind has no "finger" variant. Below `lg` (phones and portrait tablets) and wherever the main pointer
// is coarse (a tablet in landscape) the small controls of a post grow to a size a finger can hit; a mouse
// keeps the compact look. The class names are written out in full because Tailwind reads them as text.

/** A button that is only an icon or a short label. */
export const TOUCH_TARGET =
  "max-lg:min-h-10 max-lg:min-w-10 [@media(pointer:coarse)]:min-h-10 [@media(pointer:coarse)]:min-w-10";

/** A pill beside other pills, where a full 40 px would crowd the row. */
export const TOUCH_TARGET_PILL =
  "max-lg:min-h-9 [@media(pointer:coarse)]:min-h-9";

/** A row of small text buttons: every button in it gets the vertical padding of a finger target. */
export const TOUCH_BUTTON_ROW =
  "max-lg:[&_button]:py-2 [@media(pointer:coarse)]:[&_button]:py-2";
